export const ADD_THERAPISTS = "ADD_THERAPISTS";
export const ADD_FILTERED_THERAPISTS = "ADD_FILTERED_THERAPISTS";
export const ADD_PAGINATE_THERAPISTS = "ADD_PAGINATE_THERAPISTS";
export const CLEAR_THERAPISTS = "CLEAR_THERAPISTS";